module.exports = __webpack_public_path__ + "static/media/tensorflow.d842b85a.svg";